import React, { useContext } from 'react';
import { LoaderMain, SharedConfigContext } from '@bepro-travel/fe.shared';
import { FC, Fragment } from 'react';
import Skeleton from 'react-loading-skeleton';
import { cdnUrl, sharedConfig } from '../../constants';

const OphirBookSkeleton: FC = () => {
  return (
    <Fragment>
      <div className="details book">
        <div className="book-form default-shadow">
          <div className="title-underline text-lg mb-20">
            <Skeleton width={320} />
          </div>
          <div>
            {[...Array(2)].map((_, index) => (
              <div className="book-form-room" key={index}>
                <div className="title text-md mb-15">
                  <span className="mr-5">
                    <Skeleton width={200} />
                  </span>

                  <span className="text-sm text-light text-normal">
                    <Skeleton width={300} />
                  </span>
                </div>
                <div className="form-wrapper row">
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                  <div className="col-md-6 col-12">
                    <Skeleton width={140} className="mb-5" />
                    <Skeleton width={'100%'} height={38} className="mb-20" />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="title text-md mb-15">
            <Skeleton width={200} />
          </div>
          <div className="book-payment mb-20">
            <div className="title text-md mb-20 mt-10">
              <Skeleton height={30} />
            </div>
            <div className="form-wrapper row">
              <div className="col-md-3 col-12">
                <Skeleton width={'100%'} height={38} className="mb-5" />
              </div>
              <div className="col-md-6 col-12">
                <Skeleton width={'50%'} height={38} className="mb-5" />
              </div>
              <div className="col-md-3 col-12">
                <Skeleton width={120} height={38} className="mb-5" />
              </div>
            </div>
            <div className="flex-between form-wrapper row">
              <div className="col-12 col-md-9">
                <Skeleton width={220} height={30} className="mb-5" />
              </div>

              <div className="col-md-3 col-12">
                <Skeleton width={120} height={38} className="mb-5" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="oph-book-sidebar">
        <div className="oph-table-sm-wr default-shadow">
          <table className="oph-table-sm oph-table-sm-room">
            <thead>
              <tr>
                <th>
                  <Skeleton width={130} />
                </th>
                <th>
                  <Skeleton width={100} />
                </th>
                <th>
                  <Skeleton width={120} />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <Skeleton width={130} height={33} />
                </td>
                <td>
                  <Skeleton width={100} />
                </td>
                <td>
                  <Skeleton width={130} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="oph-table-sm-wr default-shadow mt-30">
          <div className="oph-table-sm-title">
            <Skeleton width={200} />
          </div>
          <table className="oph-table-sm">
            <tbody>
              {[...Array(2)].map((_, index) => (
                <tr key={index}>
                  <td>
                    <div className="oph-table-sm-logo">
                      <Skeleton width={60} height={50} />
                      <span className="name">
                        <Skeleton width={150} />
                      </span>
                    </div>
                  </td>
                  <td>
                    <div>
                      <Skeleton width={60} />
                    </div>
                  </td>
                  <td>
                    <div>
                      <Skeleton width={60} />
                    </div>
                    <div>
                      <Skeleton width={44} />
                    </div>
                  </td>
                  <td>
                    <div>
                      <Skeleton width={60} />
                    </div>
                  </td>
                  <td>
                    <div>
                      <Skeleton width={60} />
                    </div>
                    <div>
                      <Skeleton width={44} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div
          className="default-shadow mt-30"
          style={{ overflow: 'hidden', background: 'var(--color-bg-light)' }}
        >
          <div className="oph-table-sm-title mb-10">
            <Skeleton width={200} />
          </div>
          <div className="mb-10">
            <Skeleton width={230} className="ml-10" />
          </div>
          <div className="mb-10">
            <Skeleton width={240} className="ml-10" />
          </div>
          <div className="mb-10">
            <Skeleton width={150} className="ml-10" />
          </div>
          <div className="mb-10">
            <Skeleton width={120} className="ml-10" />
          </div>
        </div>
      </div>
      <SharedConfigContext.Provider
        value={{
          ...sharedConfig,
          cdnUrl,
          userSiteConfig: {},
          setUserSiteConfig: () => { },
          proposal: {
            flights: [],
            hotels: [],
            dynamic: [],
            ilPackages: [],
            transfers: [],
          },
          setProposal: () => { },
          defaultUserSiteConfig: {},
        }}
      >
        <LoaderMain systemProducts="Flights" systemProductsDetails="LoadingBook" />
      </SharedConfigContext.Provider>
    </Fragment>
  );
};

export default OphirBookSkeleton;
